import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TNAppDownloadCard } from './TNAppDownloadCard'

export const TNAppDownloadCardRegistration = createRegisterableComponent(
    'tn-app-download-card',
    () => <TNAppDownloadCard />,
)
